import { pendo } from '@frontend/tracking';

const BASE_EVENT_PREFIX = 'call-intel-backfill';

export const backfillBannerPendoEvents = {
  // Call recordings disabled banner - single visibility event (scenario in metadata)
  recordingsDisabledBannerSeen: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-seen`,

  // Batch 1 banner
  batch1BannerSeen: `${BASE_EVENT_PREFIX}-batch1-banner-seen`,

  // Batch 2 banner
  batch2BannerSeen: `${BASE_EVENT_PREFIX}-batch2-banner-seen`,

  // Mixed banner
  mixedBannerSeen: `${BASE_EVENT_PREFIX}-mixed-banner-seen`,
} as const;

export const backfillBannerTrackingIds = {
  recordingsDisabledBannerCta: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-cta`,
  recordingsDisabledBannerDismiss: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-dismiss`,

  batch1BannerCta: `${BASE_EVENT_PREFIX}-batch1-banner-cta`,
  batch1BannerDismiss: `${BASE_EVENT_PREFIX}-batch1-banner-dismiss`,

  batch2BannerCta: `${BASE_EVENT_PREFIX}-batch2-banner-cta`,
  batch2BannerDismiss: `${BASE_EVENT_PREFIX}-batch2-banner-dismiss`,

  mixedBannerCta: `${BASE_EVENT_PREFIX}-mixed-banner-cta`,
  mixedBannerDismiss: `${BASE_EVENT_PREFIX}-mixed-banner-dismiss`,
} as const;

export const trackBackfillBannerEvent = (
  eventName: (typeof backfillBannerPendoEvents)[keyof typeof backfillBannerPendoEvents],
  metadata?: { [key: string]: any }
) => {
  pendo.track(eventName, metadata);
};
